import { Button, Grid, Menu, MenuItem, Stack, SvgIcon, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Search from '../dashboard/patients/patient-listing-search';
import ListingTable from './table';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { getListOfMonthAlertRequest } from 'src/redux/actions/monthEndAlertsAction';
import loader from 'src/components/LoaderImg/loader.gif';
import RightCheck from 'src/icons/untitled-ui/duocolor/rightCheck';
import ErrorIconAlert from 'src/icons/untitled-ui/duocolor/month-end-alerts/errorIcon';
import WarningIconAlert from 'src/icons/untitled-ui/duocolor/month-end-alerts/warningIcon';
import IgnoreIconAlert from 'src/icons/untitled-ui/duocolor/month-end-alerts/ignoreIcon';
import { Print } from '@mui/icons-material';
import MEAPrintDialog from './MEAPrintDialog';

type Props = {
  filterOption: string;
  dateRange: any;
};

type FilterProps = {
  label: string;
  value: string;
} | null;

type SortOptions = {
  sortBy: 'title' | 'theme' | 'therapist' | 'patientName' | 'document' | 'dueDate';
  sortDirection: 'asc' | 'desc';
};

const MonthAlertTableView = (props: Props) => {
  const { filterOption, dateRange } = props;
  const dispatch = useDispatch();
  const [pageNo, setPageNo] = useState<number>(0);
  const [rowPerPage, setRowPerPage] = useState<number>(20);
  const [anchorFilterEl, setAnchorFilterEl] = React.useState<null | HTMLElement>(null);
  const openFilter = Boolean(anchorFilterEl);
  const handleFilterClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorFilterEl(event.currentTarget);
  };

  const [anchorSortEl, setAnchorSortEl] = React.useState<null | HTMLElement>(null);
  const openSort = Boolean(anchorSortEl);

  const [searchData, setSearchData] = useState('');
  const onPageChange = (event: any, newPage: number) => {
    setPageNo(newPage);
  };

  const [sortOptions, setSortOptions] = useState<SortOptions>({
    sortBy: 'dueDate',
    sortDirection: 'desc'
  });
  const [isPrintDialogOpen, setIsPrintDialogOpen] = useState(false);

  const onRowsPerPageChange = (event: any) => {
    setPageNo(0);
    setRowPerPage(event.target.value);
  };

  const getListofMonthEndAlertData = useSelector(
    (state: any) => state?.getListofMonthEndAlertReducer
  );

  const filters: FilterProps[] = [
    { label: 'Error', value: 'ERROR' },
    { label: 'Warning', value: 'WARNING' },
  ];

  const sortCriteria: FilterProps[] = [
    { label: 'Due Date', value: 'dueDate' },
    // { label: 'Theme', value: 'theme' },
    // { label: 'Status', value: 'status' },
    { label: 'Owner Name A-Z', value: 'owner' },
    { label: 'Patient Name A-Z', value: 'patient' },
  ];

  const [activeFilter, setActiveFilter] = useState<any>({
    filter: null,
    sort: sortCriteria && sortCriteria[0],
  });

  const handleFilterClose = (e: any, item: FilterProps) => {
    if (item) {
      if (activeFilter.filter && activeFilter.filter.value === item.value) {
        setActiveFilter((prevState: any) => ({
          ...prevState,
          filter: null,
        }));
      } else {
        setActiveFilter((prevState: any) => ({
          ...prevState,
          filter: item,
        }));
      }
    } else {
      setActiveFilter(activeFilter);
    }
    setAnchorFilterEl(null);
  };

  const handleSortClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorSortEl(event.currentTarget);
  };

  const handleSortClose = (e: any, item: FilterProps) => {
    if (item) {
      setActiveFilter((prevState: any) => ({
        ...prevState,
        sort: item,
      }));
    } else {
      setActiveFilter(activeFilter);
    }
    setAnchorSortEl(null);
  };

  const handlePrint = () => {
    setIsPrintDialogOpen(true);
  };
  const handleClosePrintDialog = () => {
    setIsPrintDialogOpen(false);
  };

  useEffect(() => {
    dispatch(
      getListOfMonthAlertRequest({
        param: {
          type: activeFilter.filter ? activeFilter.filter.value : undefined,
          sortBy: sortOptions.sortBy,
          sortDirection: sortOptions.sortDirection,
          searchString: searchData,
          page: pageNo,
          pageSize: rowPerPage,
          ...dateRange,
        },
        source: 'CLOSEOUT',
      })
    );
  }, [searchData, filterOption, activeFilter, pageNo, rowPerPage, sortOptions]);

  useEffect(() => {
    if (!searchData) return;
    setPageNo(0);
    setRowPerPage(20);
  }, [searchData]);

  return (
    <Stack
      gap="1rem"
      sx={{ width: '98%', margin: '0 auto' }}
    >
      <Stack
        gap="1.5rem"
        flexDirection="row"
        justifyContent={'space-between'}
      >
        <Button
          color="inherit"
          id="basic-button"
          aria-controls={openFilter ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={openFilter ? 'true' : undefined}
          onClick={handleFilterClick}
          endIcon={<KeyboardArrowDownOutlinedIcon />}
        >
          Filter by {activeFilter?.filter?.label || ''}
        </Button>

        <Button
          onClick={handlePrint}
          startIcon={<Print />}
          fullWidth
          disabled={!getListofMonthEndAlertData.response?.totalElements}
          sx={{ color: '#6366F1', width: '60px', height: '40px' }}
        >
          Print
        </Button>
        {/* <Button
          color="inherit"
          id="sort-button"
          aria-controls={openSort ? 'sort-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={openSort ? 'true' : undefined}
          onClick={handleSortClick}
          endIcon={<KeyboardArrowDownOutlinedIcon />}
        >
          {' '}
          Sort by {activeFilter.sort.label}
        </Button> */}
        <Menu
          id="basic-menu"
          anchorEl={anchorFilterEl}
          open={openFilter}
          onClose={(e) => handleFilterClose(e, null)}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
          PaperProps={{
            style: {
              width: 180,
            },
          }}
        >
          {filters.map((item: FilterProps, index: number) => {
            return (
              <MenuItem
                key={index}
                onClick={(e) => handleFilterClose(e, item)}
              >
                <Grid container>
                  <SvgIcon>
                    {item?.value === 'ERROR' ? (
                      <ErrorIconAlert />
                    ) : item?.value === 'WARNING' ? (
                      <WarningIconAlert />
                    ) : item?.value === 'IGNORE' ? (
                      <IgnoreIconAlert />
                    ) : null}
                  </SvgIcon>
                  <Typography
                    fontSize={'14px'}
                    sx={{ marginLeft: '12px' }}
                  >
                    {item?.label}
                  </Typography>
                  {item?.value === activeFilter?.filter?.value && (
                    <SvgIcon sx={{ position: 'absolute', right: 8 }}>
                      <RightCheck />
                    </SvgIcon>
                  )}
                </Grid>
              </MenuItem>
            );
          })}
        </Menu>
        <Menu
          id="sort-menu"
          anchorEl={anchorSortEl}
          open={openSort}
          onClose={(e) => handleSortClose(e, null)}
          MenuListProps={{
            'aria-labelledby': 'sort-button',
          }}
          PaperProps={{
            style: {
              width: 180,
            },
          }}
        >
          {sortCriteria.map((item: FilterProps, index: number) => {
            return (
              <MenuItem
                onClick={(e) => handleSortClose(e, item)}
                key={index}
              >
                <Grid container>
                  <Typography fontSize={'14px'}>{item?.label}</Typography>
                  {item?.value === activeFilter.sort.value && (
                    <SvgIcon sx={{ position: 'absolute', right: 8 }}>
                      <RightCheck />
                    </SvgIcon>
                  )}
                </Grid>
              </MenuItem>
            );
          })}
        </Menu>
      </Stack>
      <Search
        setSearchData={setSearchData}
        searchData={searchData}
        placeholder="Search by keyword,alerts,theme, etc..."
      />
      {getListofMonthEndAlertData?.loading ? (
        <img
          src={loader}
          style={{ margin: 'auto', marginTop: '20px' }}
        />
      ) : (
        <ListingTable
          count={getListofMonthEndAlertData.response?.totalElements}
          items={getListofMonthEndAlertData.response?.content}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
          page={pageNo}
          rowsPerPage={rowPerPage}
          sortOptions={sortOptions}
          setSortOptions={setSortOptions}
          setRowPerPage={setRowPerPage}
          setPageNo={setPageNo}
        />
      )}

      <MEAPrintDialog
        startDate={dateRange?.startDate}
        endDate={dateRange?.endDate}
        open={isPrintDialogOpen}
        onClose={handleClosePrintDialog}
      />
    </Stack>
  );
};

export default MonthAlertTableView;
